/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum Tariff {
  Self = 'SELF',
  Optimal = 'OPTIMAL',
  AllInclusive = 'ALL_INCLUSIVE',
  WithGuarantee = 'WITH_GUARANTEE',
}

export function instanceOfTariff(value: any): boolean {
  for (const key in Tariff) {
    if (Object.prototype.hasOwnProperty.call(Tariff, key)) {
      if (Tariff[key as keyof typeof Tariff] === value) {
        return true
      }
    }
  }
  return false
}

export function TariffFromJSON(json: any): Tariff {
  return TariffFromJSONTyped(json, false)
}

export function TariffFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Tariff {
  return json as Tariff
}

export function TariffToJSON(value?: Tariff | null): any {
  return value as any
}
